import React from "react";
import keycloakService from "../keycloakService";
import { Button } from "@mui/material";

const classes = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
  },
};

function Welcome() {
  return (
    <div style={classes.container}>
      <h1>Welcome to Data Entry Portal</h1>
      <Button
        variant="contained"
        color="primary"
        onClick={() => keycloakService.login()}
      >
        {" "}
        Go to Login
      </Button>
    </div>
  );
}

export default Welcome;
